module.exports = __webpack_public_path__ + "static/media/facebook-footer.e61c1304.svg";